// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2tIv3","header":"PatientBlock_header__2hyC5","label":"PatientBlock_label__22c-t","option":"PatientBlock_option__3O9Ot"};